export class DefectV10 {
    static constructFromPlainObject(sourceDefect) {
        const defect = new DefectV10(sourceDefect.code, sourceDefect.description, sourceDefect.type);
        defect.setPositionNumber(sourceDefect.positionNumber);
        defect.setSelected(!!sourceDefect.selected);
        return defect;
    }
    constructor(code, description, type) {
        this.code = code;
        this.description = description;
        this.type = type;
        this.selected = false;
    }
    getCode() {
        return this.code;
    }
    getDescription() {
        return this.description;
    }
    getType() {
        return this.type;
    }
    getPositionNumber() {
        return this.positionNumber;
    }
    setPositionNumber(positionNumber) {
        this.positionNumber = positionNumber;
    }
    isSelected() {
        return this.selected;
    }
    setSelected(selected) {
        this.selected = selected;
    }
}
//# sourceMappingURL=defectV10.js.map